export default __webpack_public_path__ + "static/media/europe_achievement.d99bc705.png";